import { IFormOptions } from "modules/forms/types/IFormOptions";
import { validationRegexTypes } from "modules/validation/constants/validation-regex.constants";
import { ValidationRule } from "modules/validation/rules/default.validation-rules";
import { ObservationLocationTypeEnum } from "shared/enums/ObservationLocationType.enum";
import { OpportunityEntity } from "shared/types/domain/OpportunityEntity";
import { keysAreEqual } from "shared/utils/equality.utils";

export const ammendOpportunityOptions: IFormOptions<OpportunityEntity> = {

    fields: {
        nearMissId: {
            rules: []
        },
        reachId: {
            rules: [
                {
                    name: ValidationRule.Required
                }
            ]
        },
        processId: {
            rules: [
                {
                    name: ValidationRule.Required
                }
            ]
        },
        depotPcId: {
            rules: [
                {
                    name: ValidationRule.Required
                }
            ]
        },
        whatHappened: {
            rules: [
                {
                    name: ValidationRule.Required
                },
                {
                    data: {
                        length: 600
                    },
                    name: ValidationRule.MaxLength
                }
            ]
        },
        whoShouldBeCommended: {
            rules: [
                {
                    name: ValidationRule.Required
                },
                {
                    data: {
                        length: 600
                    },
                    name: ValidationRule.MaxLength
                }
            ]
        },
        reporterType: {
            rules: [
                {
                    name: ValidationRule.Required
                }
            ]
        },
        anonymousEntry: {
            rules: [
                {
                    name: ValidationRule.Required
                }
            ]
        },
        reporterContactName: {
            rules: [
                {
                    condition: data => !data?.anonymousEntry,
                    name: ValidationRule.Required
                },
                {
                    data: {
                        length: 30
                    },
                    name: ValidationRule.MaxLength
                }
            ]
        },
        reporterPhoneNumber: {
            rules: [
                {
                    condition: data => !data?.anonymousEntry,
                    name: ValidationRule.Required
                },
                {
                    data: { regex: validationRegexTypes.Telephone },
                    name: ValidationRule.Regex
                },
                {
                    data: {
                        length: 50
                    },
                    name: ValidationRule.MaxLength
                }
            ]
        },
        reporterEmail: {
            rules: [
                {
                    condition: data => !data?.anonymousEntry,
                    name: ValidationRule.Required
                },
                {
                    data: { regex: validationRegexTypes.Email },
                    name: ValidationRule.Regex
                },
                {
                    data: {
                        length: 50
                    },
                    name: ValidationRule.MaxLength
                }
            ]
        },
        incidentDate: {
            rules: [
                {
                    condition: data => !data?.incidentDate,
                    name: ValidationRule.Required
                },
                {
                    name: ValidationRule.FutureDate
                }
            ]
        }
    }

};